import { SHOW_SNACKBAR, HIDE_SNACKBAR } from "../ActionTypes";

const initialState = {
  open: false,
  message: '',
  severity: 'info',
};

const snackbarReducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_SNACKBAR:
      return {
        ...state,
        open: true,
        message: action.payload.message,
        severity: action.payload.severity,
      };
    case HIDE_SNACKBAR:
      return {
        ...state,
        open: false,
      };
    default:
      return state;
  }
};

export default snackbarReducer;
